module.exports = __webpack_public_path__ + "media/images/icons/icn_035-d692d8db08e842a0c2b71bd0dd715ccd.svg";